import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as state from '../../../../../state'

import * as input from './input'
import * as readonly from './readonly'

/** TODO:  */
@ngCore.Component({
  imports: [readonly.Component, input.Component],
  selector: 'atn-display-value',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Controls display between {@link readonly.Component} or {@link input.Component} */
  public readonly readonlySg = ngCore.input<boolean>(undefined, {
    alias: 'readonly',
  })

  //  TODO: Implement placeholder input

  /** @see {@link ents.core.dms.data.Value.Type} */
  public readonly typeSg = ngCore.input<ents.core.dms.data.Value.Type>(
    undefined,
    {
      alias: 'type',
    },
  )

  /** @see {@link ents.core.dms.data.Value} */
  public readonly valueSg = ngCore.input.required<ents.core.dms.data.Value>({
    alias: 'value',
  })

  /** TODO:  */
  public readonly labelSg = ngCore.input<string>(undefined, {
    alias: 'label',
  })

  /** @see {@link input.Component.requiredSg}  */
  public readonly requiredSg = ngCore.input<boolean>(false, {
    alias: 'required',
  })

  /**
   * Files-attribute-only pass-through; ignored by every other value type.
   * TODO: revisit — leaking Files concerns through the generic typed-value pipeline.
   *
   * @see {@link input.Component.documentKeySg}
   */
  public readonly documentKeySg = ngCore.input<
    state.kbDocumentUploads.DocumentKey | undefined
  >(undefined, { alias: 'documentKey' })

  /**
   * Files-attribute-only pass-through; ignored by every other value type.
   * TODO: revisit — leaking Files concerns through the generic typed-value pipeline.
   *
   * @see {@link input.Component.recordTargetSg}
   */
  public readonly recordTargetSg = ngCore.input<
    ents.core.agent.KnowledgeBase.Target.Record | undefined
  >(undefined, { alias: 'recordTarget' })

  /** TODO Fix casting*/
  public readonly typedValueSg = ngCore.computed(
    (type = this.typeSg(), value = this.valueSg()) =>
      ({ type, value }) as ents.core.dms.data.Value.ValueWithType.Strict,
  )

  /** Emitting changed value */
  public valueChange = ngCore.output<ents.core.dms.data.Value>()

  /** Takes typedValue event and emits typedValue.value */
  public typedValueChangeHandler(
    typedValue: ents.core.dms.data.Value.ValueWithType.Strict,
  ) {
    this.valueChange.emit(typedValue.value)
  }
}
